module.exports = __webpack_public_path__ + "img/main-btn-logo.7d2c6ff4.svg";